import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface DateOnlyProps {
    dateUtc: string;
}

export default function DateOnly({ dateUtc }: DateOnlyProps) {
    const { i18n } = useTranslation();
    const [formatted, setFormatted] = useState("");

    useEffect(() => {
        if (!dateUtc) return;

        const date = new Date(dateUtc);

        const formattedDate = new Intl.DateTimeFormat(i18n.language, {
            year: "numeric",
            month: "long",
            day: "numeric"
        }).format(date);

        setFormatted(formattedDate);
    }, [dateUtc, i18n.language]);

    return <span>{formatted}</span>;
}
